import { render } from "./NavbarForums.vue?vue&type=template&id=7ee3733a"
import script from "./NavbarForums.vue?vue&type=script&lang=js"
export * from "./NavbarForums.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__